<template>
  <v-container fluid class="px-0">
    <v-dialog v-model="dialogCarregando" persistent overlay-opacity="0.5" width="350px">
      <v-card color="green darken-2" dark>
        <v-card-text class="pa-5">
          Carregando PDF, aguarde.
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <RequisicaoPDF ref="requisicaoPDF" />
    <v-card elevation="2" class="mx-auto">
      <v-card-title class="white--text green darken-2 py-4 px-5 d-flex align-center">
        <v-icon left color="white">mdi-fuel</v-icon>
        Requisições {{ $vuetify.breakpoint.smAndDown ? '' : ' de Abastecimento'}}
        <v-spacer></v-spacer>
        <v-btn
            color="white"
            outlined
            @click="$router.push({ name: 'financeiro-abastecimentos-requisicoes-novo' })"
        >
          <v-icon>mdi-plus</v-icon>
          <span class="ml-2 d-none d-sm-flex">Nova Requisição</span>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Filtros -->
      <v-expansion-panels v-model="panelFiltros" accordion flat>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center">
              <v-icon left color="primary">mdi-filter-variant</v-icon>
              <span class="font-weight-medium">Filtros de Busca</span>
              <v-spacer></v-spacer>
              <v-chip
                  v-if="filtrosAtivos > 0"
                  small
                  color="primary"
                  text-color="white"
                  class="mr-2"
              >
                {{ filtrosAtivos }} filtro{{ filtrosAtivos > 1 ? 's' : '' }} ativo{{ filtrosAtivos > 1 ? 's' : '' }}
              </v-chip>
            </div>
          </v-expansion-panel-header>
          <v-divider/>
          <v-expansion-panel-content>
            <v-card-text class="pt-0">
              <v-row dense>
                <!-- Filial -->
                <v-col cols="12" md="3">
                  <v-select
                      v-model="filtros.idfilial"
                      :items="filiaisFiltro"
                      item-text="filial"
                      item-value="idfilial"
                      label="Filial"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-office-building"
                      @change="aplicarFiltros(); listarVeiculos()"
                      hide-details
                  />
                </v-col>

                <!-- Veículo -->
                <v-col cols="12" md="3">
                  <v-autocomplete
                      v-model="filtros.idveiculo"
                      :items="veiculos"
                      item-text="veiculoplaca"
                      item-value="idveiculo"
                      label="Veículo"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-car"
                      @change="aplicarFiltros()"
                      hide-details
                  />
                </v-col>

                <!-- Status -->
                <v-col cols="12" md="3">
                  <v-select
                      v-model="filtros.idstatus"
                      :items="statusOptions"
                      item-text="status"
                      item-value="idstatus"
                      label="Status"
                      outlined
                      dense
                      clearable
                      prepend-inner-icon="mdi-check-circle"
                      @change="aplicarFiltros()"
                      hide-details
                  />
                </v-col>

                <!-- Botão Limpar Filtros -->
                <v-col cols="12" md="3">
                  <v-btn
                      color="grey"
                      outlined
                      block
                      @click="limparFiltros"
                      height="40"
                      :disabled="filtrosAtivos === 0"
                  >
                    <v-icon left>mdi-filter-remove</v-icon>
                    Limpar Filtros
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-divider></v-divider>

      <!-- Tabela -->
      <v-card-text class="pa-0">
        <v-data-table
            :headers="headers"
            :items="requisicoesFiltered"
            :loading="carregando"
            :items-per-page="25"
            :footer-props="{
              'items-per-page-text': 'Itens por página:',
              'items-per-page-options': [25, 50, 100, { text: 'Todos', value: -1 }]
            }"
            class="elevation-0"
            no-data-text="Nenhuma requisição encontrada"
            loading-text="Carregando requisições..."
            :search="busca"
            :sort-by="['idrequisicao']"
            :sort-desc="[true]"
        >
          <!-- Slot para formatação da data -->
          <template v-slot:item.dtmovimento="{ item }">
            <span>{{ item.dtmovimento | formataData }}</span>
          </template>

          <!-- Slot para formatação do status -->
          <template v-slot:item.status="{ item }">
            <v-chip
                :color="getStatusColor(item.idstatus)"
                text-color="white"
                small
                label
            >
              {{ item.status }}
            </v-chip>
          </template>

          <!-- Slot para ações com menu -->
          <template v-slot:item.acoes="{ item }">
            <v-menu bottom left offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item @click="visualizarPDF(item)">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Visualizar PDF</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="editarRequisicao(item)" v-if="false">
                  <v-list-item-icon>
                    <v-icon color="orange">mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Editar</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="lancarDespesa(item)" :disabled="item.idstatus === 2">
                  <v-list-item-icon>
                    <v-icon :color="item.idstatus === 2 ? 'grey' : 'green'">mdi-invoice-text-send</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Lançar Despesa</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list-item @click="confirmarExclusao(item)">
                  <v-list-item-icon>
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Excluir</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Dialog de Visualização -->
    <v-dialog v-model="dialogVisualizacao" max-width="900px" scrollable>
      <v-card v-if="requisicaoSelecionada">
        <v-card-title class="green darken-2 white--text">
          <v-icon left color="white">mdi-eye</v-icon>
          Detalhes da Requisição #{{ requisicaoSelecionada.idrequisicao }}
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="dialogVisualizacao = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6" v-if="false">
          <v-row>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Data da Requisição:</div>
                <div class="info-value">{{ requisicaoSelecionada.dtmovimento | formataData }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">ID da Requisição:</div>
                <div class="info-value">#{{ requisicaoSelecionada.idrequisicao }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Veículo:</div>
                <div class="info-value">{{ requisicaoSelecionada.veiculo || '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Placa:</div>
                <div class="info-value">{{ requisicaoSelecionada.placa || '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Colaborador:</div>
                <div class="info-value">{{ requisicaoSelecionada.colaborador || '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Filial:</div>
                <div class="info-value">{{ requisicaoSelecionada.empresa || '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Tipo de Requisição:</div>
                <div class="info-value">{{ getTipoRequisicaoText(requisicaoSelecionada.tipoabastecimento) }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Status:</div>
                <div class="info-value">
                  <v-chip
                      :color="getStatusColor(requisicaoSelecionada.idstatus)"
                      text-color="white"
                      small
                      label
                  >
                    {{ getStatusText(requisicaoSelecionada.status) }}
                  </v-chip>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Litros:</div>
                <div class="info-value">{{ requisicaoSelecionada.quantidade ? Number(requisicaoSelecionada.quantidade).toLocaleString('pt-BR') + ' L' : '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Valor:</div>
                <div class="info-value">{{ requisicaoSelecionada.valor ? formatarMoeda(requisicaoSelecionada.valor) : '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Usuário:</div>
                <div class="info-value">{{ requisicaoSelecionada.usuario || '-' }}</div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <div class="info-label">Hodômetro:</div>
                <div class="info-value">{{ requisicaoSelecionada.odometro ? Number(requisicaoSelecionada.odometro).toLocaleString('pt-BR') + ' KM' : '-' }}</div>
              </div>
            </v-col>

            <!-- Imagem do Hodômetro -->
            <v-col cols="12" v-if="requisicaoSelecionada.path">
              <div class="info-item">
                <div class="info-label">Imagem do Hodômetro:</div>
                <div class="info-value">
                  <iframe
                      :src="requisicaoSelecionada.path"
                      width="100%"
                      height="300"
                      style="border: 1px solid #ddd;"
                  ></iframe>
<!--                  <v-img-->
<!--                      max-width="300"-->
<!--                      max-height="200"-->
<!--                      class="mt-2"-->
<!--                      @click="visualizarImagemCompleta(requisicaoSelecionada.imagem_odometro)"-->
<!--                      style="cursor: pointer; border: 1px solid #ddd; border-radius: 4px;"-->
<!--                  >-->
<!--                    <template v-slot:placeholder>-->
<!--                      <v-row class="fill-height ma-0" align="center" justify="center">-->
<!--                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>-->
<!--                      </v-row>-->
<!--                    </template>-->
<!--                  </v-img>-->
                  <div class="caption grey--text mt-1">Clique para visualizar em tamanho real</div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text>
          <vue-pdf-embed
              v-if="requisicaoSelecionada.path"
              :source="requisicaoSelecionada.path"
              style="width: 100%; height: 100%;"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog para visualizar imagem completa -->
    <v-dialog v-model="dialogImagem" max-width="800px">
      <v-card>
        <v-card-title class="green darken-2 white--text">
          <v-icon left color="white">mdi-image</v-icon>
          Imagem do Hodômetro
          <v-spacer></v-spacer>
          <v-btn icon color="white" @click="dialogImagem = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-img
              :src="imagemSelecionada"
              contain
              max-height="500"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de Confirmação de Exclusão -->
    <v-dialog v-model="dialogExclusao" max-width="500px">
      <v-card>
        <v-card-title class="red darken-2 white--text">
          <v-icon left color="white">mdi-alert</v-icon>
          Confirmar Exclusão
        </v-card-title>

        <v-card-text class="pa-6 pb-0 text-center">
          <v-icon size="80" color="red" class="mb-4">mdi-delete-alert</v-icon>
          <div class="text-h6 mb-2">Tem certeza que deseja excluir esta requisição?</div>
          <div class="grey--text">
            Requisição: <strong>#{{ requisicaoParaExcluir?.idrequisicao }}</strong><br>
            Veículo: <strong>{{ requisicaoParaExcluir?.veiculo }}</strong>
          </div>
          <v-alert
              type="error"
              outlined
              class="mt-4 text-left"
          >
            Esta ação não pode ser desfeita!
          </v-alert>
        </v-card-text>

        <v-card-actions class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn
              color="grey"
              outlined
              @click="dialogExclusao = false"
              :disabled="excluindo"
          >
            Cancelar
          </v-btn>
          <v-btn
              color="red"
              class="white--text"
              @click="excluirRequisicao"
              :loading="excluindo"
              :disabled="excluindo"
          >
            <v-icon left>mdi-delete</v-icon>
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar para feedback -->
    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        top
        right
    >
      <v-icon left color="white">{{ snackbar.icon }}</v-icon>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            color="white"
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import mixinFilial from "../../../util/mixinFilial";
import RequisicaoPDF from '../Widgets/RequisicaoPDF.vue'
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";

export default {
  mixins: [mixinFilial],
  components: {
    VuePdfEmbed,
    RequisicaoPDF,
  },
  data() {
    return {
      carregando: false,
      dialogCarregando: false,
      excluindo: false,

      // Controle de painéis e dialogs
      panelFiltros: null,
      dialogVisualizacao: false,
      dialogExclusao: false,
      dialogImagem: false,

      // Dados
      requisicoes: [],
      veiculos: [],
      imagemSelecionada: null,
      busca: '',

      // Requisição selecionada para ações
      requisicaoSelecionada: null,
      requisicaoParaExcluir: null,

      // Filtros
      filtros: {
        idfilial: null,
        idveiculo: null,
        idstatus: null
      },

      // Headers da tabela
      headers: [
        { text: 'ID', value: 'idrequisicao', width: '80px' },
        { text: 'Data', value: 'dtmovimento', width: '120px' },
        { text: 'Veículo', value: 'veiculo' },
        { text: 'Placa', value: 'placa', width: '100px' },
        { text: 'Colaborador', value: 'colaborador' },
        { text: 'Filial', value: 'empresa', width: '150px' },
        { text: 'Status', value: 'status', width: '120px', align: 'center' },
        { text: 'Ações', value: 'acoes', align: 'center', width: '80px', sortable: false }
      ],

      // Opções de status
      statusOptions: [
        { status: 'Aguardando', idstatus: 1 },
        { status: 'Concluído', idstatus: 2 }
      ],

      // Snackbar
      snackbar: {
        show: false,
        message: '',
        color: 'success',
        icon: 'mdi-check-circle',
        timeout: 4000
      }
    };
  },

  computed: {
    ...mapState(["backendUrl", "timeLimit", "usuario"]),

    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial !== 6 &&
              v.idfilial !== 12 &&
              v.idfilial !== 25 &&
              v.idfilial !== 29 &&
              v.idfilial !== 33 &&
              v.idfilial !== 37
          );
        });
      } else {
        return [];
      }
    },

    filtrosAtivos() {
      let count = 0;
      if (this.filtros.idfilial) count++;
      if (this.filtros.idveiculo) count++;
      if (this.filtros.idstatus) count++;
      return count;
    },

    requisicoesFiltered() {
      let filtered = [...this.requisicoes];

      // Aplicar filtro de filial
      if (this.filtros.idfilial) {
        filtered = filtered.filter(req => req.idfilial === this.filtros.idfilial);
      }

      // Aplicar filtro de veículo
      if (this.filtros.idveiculo) {
        filtered = filtered.filter(req => req.idveiculo === this.filtros.idveiculo);
      }

      // Aplicar filtro de status
      if (this.filtros.idstatus) {
        filtered = filtered.filter(req => req.idstatus === this.filtros.idstatus);
      }

      return filtered;
    }
  },

  methods: {
    async visualizarPDF(requisicao) {
      this.dialogCarregando = true;
      let arquivoBase64 = null;

      await axios.post(`${this.backendUrl}tms/requisicao/dow`, {
        idrequisicao: requisicao.idrequisicao
      })
      .then(res => {
        if (res.data && res.data.arquivoBase64) {
          arquivoBase64 = res.data.arquivoBase64;
        }
      })
      .catch(err => {
        console.warn('Sem imagem hodometro', err);
      });

      try {
        this.$refs.requisicaoPDF.visualizarPDF(requisicao, arquivoBase64);
      } catch (error) {
        console.error('Erro ao renderizar o PDF no componente:', error);
        this.mostrarSnackbar('Erro ao visualizar PDF', 'error');
      }
      finally {
        this.dialogCarregando = false;
      }
    },


    async listarRequisicoes() {
      this.carregando = true;

      try {
        const response = await axios.post(`${this.backendUrl}tms/requisicao/listar`, {});

        if (response.data) {
          this.requisicoes = response.data || [];
        } else {
          this.requisicoes = [];
        }

        const requisicao = await this.requisicoes.find(r => r.idrequisicao === this.$route.params.requisicao);
        if (requisicao) {
          this.visualizarPDF(requisicao);
        }

      } catch (error) {
        console.error('Erro ao carregar requisições:', error);
        this.mostrarSnackbar('Erro ao carregar requisições', 'error');
        this.requisicoes = [];
      } finally {
        this.carregando = false;
      }
    },

    async carregarDados(idfilial) {
      try {
        await this.listarVeiculos(idfilial);
        await this.listarRequisicoes();
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        this.mostrarSnackbar('Erro ao carregar dados iniciais', 'error');
      }
    },

    async listarVeiculos(idfilial) {
      try {
        const response = await axios.post(`${this.backendUrl}tms/veiculo/listar`, {
          idfilial: this.filtros.idfilial || idfilial || null
        });

        if (response.data) {
          this.veiculos = response.data;
        }
      } catch (error) {
        console.error('Erro ao carregar veículos:', error);
        this.veiculos = [];
      }
    },

    // Métodos de filtro
    aplicarFiltros() {
      localStorage.setItem("filtros_requisicao", JSON.stringify(this.filtros));
      // this.listarRequisicoes();
    },

    limparFiltros() {
      this.filtros = {
        idfilial: null,
        idveiculo: null,
        idstatus: null
      };
      this.aplicarFiltros();
    },

    editarRequisicao(item) {
      this.$router.push({
        name: 'requisicoes-novo',
        params: { id: item.idrequisicao }
      });
    },

    lancarDespesa(item) {
      this.$router.push({
        name: 'financeiro-abastecimentos-despesas-novo',
        params: { requisicao: item.idrequisicao , idfilial: item.idfilial }
      });
    },

    confirmarExclusao(item) {
      this.requisicaoParaExcluir = { ...item };
      this.dialogExclusao = true;
    },

    async excluirRequisicao() {
      if (!this.requisicaoParaExcluir) return;

      this.excluindo = true;

      try {
        await axios.post(`${this.backendUrl}tms/requisicao/inserir`, {
          idrequisicao: this.requisicaoParaExcluir.idrequisicao,
          acao: "D"
        });

        this.mostrarSnackbar('Requisição excluída com sucesso!', 'success');
        this.dialogExclusao = false;
        this.requisicaoParaExcluir = null;
        this.listarRequisicoes();
      } catch (error) {
        console.error('Erro ao excluir requisição:', error);
        this.mostrarSnackbar('Erro ao excluir requisição', 'error');
      } finally {
        this.excluindo = false;
      }
    },

    formatarMoeda(valor) {
      if (!valor) return '-';
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);
    },

    getStatusColor(status) {
      const colors = {
        1: 'orange',
        2: 'green'
      };
      return colors[status] || 'grey';
    },

    getStatusText(status) {
      const texts = {
        1: 'Aguardando',
        2: 'Concluído'
      };
      return texts[status] || status;
    },

    getTipoRequisicaoText(tipo) {
      const tipos = {
        'por_valor': 'Por Valor',
        'por_litro': 'Por Litro',
        'completar': 'Completar'
      };
      return tipos[tipo] || tipo;
    },

    mostrarSnackbar(message, type = 'success') {
      const config = {
        success: { color: 'success', icon: 'mdi-check-circle' },
        error: { color: 'error', icon: 'mdi-alert-circle' },
        warning: { color: 'warning', icon: 'mdi-alert' },
        info: { color: 'info', icon: 'mdi-information' }
      };

      this.snackbar = {
        show: true,
        message,
        color: config[type]?.color || 'success',
        icon: config[type]?.icon || 'mdi-check-circle',
        timeout: 4000
      };
    },

    async verificaFiltros() {
      const json = localStorage.getItem("filtros_requisicao");
      const filtros = JSON.parse(json);
      if (filtros) {
        this.filtros = filtros;
        await this.carregarDados(filtros.idfilial);
      } else {
        await this.carregarDados();
      }
    },

    async init() {
      await this.verificaFiltros();
    }
  },

  created() {
    this.init();
  },
};
</script>

<style scoped>
.info-item {
  margin-bottom: 0px;
}

.info-label {
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 4px;
}

.info-value {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.v-data-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table >>> th {
  background-color: #f5f5f5 !important;
  font-weight: 600 !important;
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 16px 0 0 0;
}
</style>